import { GradientHeading, Text } from '@components/Typography';
import tickerItems from '@data/facts/facts.json';
import { Box } from '@fastly/consistently';
import * as React from 'react';
import styled, { css, keyframes } from 'styled-components';

const tickerItemWidth = 460;

const TickerHeading = styled(Text).attrs({ as: 'h5' })`
  background: var(--color-background-dark);
  height: 36px; // to match the border-left of li
  width: 350px;
  position: relative;
  z-index: 1;
  padding-left: 1rem;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    background: linear-gradient(to right, var(--color-background-dark) 348px, var(--color-white) 2px);
  }
`;

const scroll = (w: number) => keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-${w}px);
  }
`;

export type TickerListProps = {
  tickerWidth: number;
};
const TickerList = styled(Text).attrs({ as: 'ul', mode: 'dark', size: 'xs' })<TickerListProps>`
  display: flex;
  align-items: center;
  animation: ${({ tickerWidth }) =>
    css`
      ${scroll(tickerWidth)} 180s linear infinite
    `};

  li {
    min-height: 36px;
    flex: 0 0 ${tickerItemWidth}px;
    padding: 0 32px;
    border-left: 2px solid var(--color-white);
  }

  &:hover {
    animation-play-state: paused;
  }

  @media (prefers-reduced-motion) {
    animation: none;
    overflow-y: auto; // no animation, but make it scrollable
  }
`;

const TickerWrap = styled(Box)`
  z-index: 50000;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    position: fixed;
    bottom: 0;
  }
`;

const Ticker = () => {
  const tickerWidth = tickerItems.length * tickerItemWidth;
  return (
    <TickerWrap
      as="section"
      display="grid"
      gridGap="sm"
      gridAutoFlow={['row', 'row', 'column']}
      overflow="hidden"
      bg="var(--color-background-dark)"
      py="md"
    >
      <TickerHeading as="h5">
        <GradientHeading as="div" small>
          Did you know?
        </GradientHeading>
        <Text as="div" mode="dark" size="xs">
          Data based on previously released Fastly reports
        </Text>
      </TickerHeading>

      <TickerList tickerWidth={tickerWidth}>
        {tickerItems.map((item: string, i: number) => (
          <li key={`ticker-${i}`}>{item}</li>
        ))}
        {tickerItems.map((item: string, i: number) => (
          <li key={`ticker-dup-${i}`}>{item}</li>
        ))}
      </TickerList>
    </TickerWrap>
  );
};

export default Ticker;
